import { TableComment } from "../../../../general/src/TableComment";
import { OriginDestinationRateTable } from "../OriginDestinationRateTable";
import { Button, Checkbox, DataHeader, DataSource, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAutoRate extends Layout {
    buttonCopy: Button;
    checkboxFriday: Checkbox;
    checkboxMonday: Checkbox;
    checkboxSaturday: Checkbox;
    checkboxSunday: Checkbox;
    checkboxThursday: Checkbox;
    checkboxTuesday: Checkbox;
    checkboxWednesday: Checkbox;
    dataheaderDataheader: DataHeader;
    labelAvailableDays: Label;
    labelOrigDestRate: Label;
    layoutOrigDestRate: OriginDestinationRateTable;
    layoutTableComment: TableComment;
    panelAutoRate: Panel;
    panelAvailableDays: Panel;
    panelHeaderFields: Panel;
    panelInfoOnly: Panel;
    panelRateSettings: Panel;
    panelRateTiming: Panel;
    sourceComments: DataSource;
    sourceOriginDestinationRate: DataSource;
    sourceOtherChargeRate: DataSource;
    sourceRate: DataSource;
    tabAdditionalCharges: Tab;
    tabComments: Tab;
    tableOtherChargeRate: Table;
    tabsetAdditionalCharges: Tabset;
    textboxCollectionMethod: Textbox;
    textboxCommodity: Textbox;
    textboxCurrency: Textbox;
    textboxCustomer: Textbox;
    textboxEffectiveDate: Textbox;
    textboxExpirationDate: Textbox;
    textboxIntrastate: Textbox;
    textboxLastUsed: Textbox;
    textboxMinimumWeight: Textbox;
    textboxMovementType: Textbox;
    textboxOrderType: Textbox;
    textboxRateNumber: Textbox;
    textboxRevenueCode: Textbox;
    textboxTieredTable: Textbox;
    textboxTimesUsed: Textbox;
    textboxTractorType: Textbox;
    textboxTrailerType: Textbox;
    textboxTruckloadLtl: Textbox;
}
